import React, { useMemo, useState } from "react";
import { C, font } from "../lib/styles.js";
import { DataContextTestProvider } from "../context/DataContext.jsx";
import CaptureLog from "../apps/jobs/views/jobcard/CaptureLog.jsx";
import ProcessingTab from "../apps/jobs/views/jobcard/ProcessingTab.jsx";
import DeliveryTab from "../apps/jobs/views/jobcard/DeliveryTab.jsx";

const BLANK_JOB = {
  id: "e2e_job",
  clientName: "E2E Client",
  jobId: "e2e_260427",
  selectedEquipment: ["Big Rig", "Canon R5"],
  crew: ["Ivin", "Ethan"],
  deliveryMethods: [],
  deliveryDate: "",
  deliveredDate: "",
  modeler: "",
  captureLog: [],
};

const PROCESS_ROW = new URLSearchParams(window.location.search).has("processRow");

function initialJob() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("protectedCaptureRow")) return BLANK_JOB;
  return {
    ...BLANK_JOB,
    captureLog: [{
      id: "cap_ingest_001",
      captureAttemptId: PROCESS_ROW ? "xrbtst2610010001" : "cap_ingest_001",
      source: "qr_scan",
      subject: "Ingest scan 01",
      displayName: "Ingest scan 01",
      subjectType: "person",
      equipment: { "Big Rig": true },
      storage: "Drive A",
      status: "captured",
      operator: "Ivin",
      notes: "Generated by ingest",
      images: [],
    }],
  };
}

const studioSettings = {
  equipment: {
    Scanners: [{ id: "big_rig", name: "Big Rig", note: "Full photogrammetry rig" }],
    Cameras: [{ id: "r5", name: "Canon R5", note: "Reference photos" }],
  },
  crewRoster: [
    { name: "Ivin", email: "", phone: "", receivesAllUpdates: true },
    { name: "Ethan", email: "", phone: "", receivesAllUpdates: true },
  ],
  storageOpts: ["Drive A", "Drive B"],
  transportOpts: ["In Studio"],
};

const TABS = ["Capture", "Processing", "Delivery"];

export default function E2EJobsFixture() {
  const [job, setJob] = useState(initialJob);
  const [tab, setTab] = useState("Capture");
  const editing = true;

  const updateJobFields = (patch) => setJob((j) => ({ ...j, ...patch }));
  const dataValue = useMemo(() => ({
    studioSettings,
    updateJob: (_jobId, patch) => updateJobFields(patch),
  }), []);

  return (
    <DataContextTestProvider value={dataValue}>
      <div style={{ minHeight: "100vh", background: C.bg, padding: 28, fontFamily: font }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
            <div>
              <div style={{ fontSize: 20, fontWeight: 500, color: C.text }}>Jobs E2E Fixture</div>
              <div style={{ fontSize: 12, color: C.muted }}>{job.clientName} · {job.jobId}</div>
            </div>
            <div style={{ fontSize: 11, color: C.amber, textTransform: "uppercase", letterSpacing: "0.12em" }}>
              Local test mode
            </div>
          </div>

          <div style={{ display: "flex", gap: 2, borderBottom: `1px solid ${C.border}`, marginBottom: 18 }}>
            {TABS.map((name) => (
              <button
                key={name}
                onClick={() => setTab(name)}
                style={{
                  padding: "9px 14px",
                  background: "transparent",
                  border: "none",
                  borderBottom: `2px solid ${tab === name ? C.text : "transparent"}`,
                  color: tab === name ? C.text : C.muted,
                  fontFamily: font,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                {name}
              </button>
            ))}
          </div>

          <div data-testid="jobs-fixture-panel" style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: 18 }}>
            {tab === "Capture" && (
              <CaptureLog
                job={job}
                editing={editing}
                isCrew={false}
                canEditShootWork={true}
                canManageJobs={true}
                updateJobFields={updateJobFields}
                // Slice 3.2: ?processRow=1 gives the seeded row a rig SN, so its Process button shows.
                canStartWork={PROCESS_ROW}
              />
            )}
            {tab === "Processing" && (
              <ProcessingTab
                job={job}
                editing={editing}
                updateJobFields={updateJobFields}
              />
            )}
            {tab === "Delivery" && (
              <DeliveryTab
                job={job}
                editing={editing}
                isCrew={false}
                updateJobFields={updateJobFields}
              />
            )}
          </div>
        </div>
      </div>
    </DataContextTestProvider>
  );
}
